module.exports = __webpack_public_path__ + "static/img/fefco713_1.5d2eedb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco713_1.png
// module id = /bys
// module chunks = 0